import { render, staticRenderFns } from "./veStuIdxEdit.vue?vue&type=template&id=a1ac5d88&scoped=true"
import script from "./veStuIdxEdit.vue?vue&type=script&lang=js"
export * from "./veStuIdxEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ac5d88",
  null
  
)

export default component.exports